// @core/api/endpoints/notifications/send_notifications_bulk.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SendNotificationsBulkRequest,
  SendNotificationsBulkResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Send notifications in bulk
 * Sends multiple notifications in a single request for efficient batch processing. Returns individual status for each notification sent.
 */
export async function SendNotificationsBulk(
  data: SendNotificationsBulkRequest,
  options?: RequestOptions
): Promise<SendNotificationsBulkResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/notifications/bulk`;
  const requestOptions = options;
  return client.post<SendNotificationsBulkResponse>(requestPath, data, requestOptions);
}
